<template>
  <a class="button" type="button" @click="$emit('click')">
    <font-awesome-icon class="icon" v-if="icon" :icon="icon" />
    <span class="title">{{ title }}</span>
  </a>
</template>

<script>
export default {
  props: ["title", "icon"],
  data() {
    return {};
  }
};
</script>

<style scoped>
.button {
  outline: none;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  font: 17px/100% Arial, Helvetica, sans-serif;
  padding: 0.32em;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
  min-height: 1.2em;
}

.button:focus,
.button:active,
.button:hover {
  opacity: 0.7;
}

.icon {
  vertical-align: middle;
  margin-right: 0.5em;
}

.title {
  vertical-align: middle;
}
</style>
